import { ProbateSummary } from './ProbateSummary';

// Mirrors CharityCentral.Server.Models.ProbateListUserRole
export enum ProbateListUserRole {
  AssignedTo = 0,
  ReportedBy = 1,
  VerifiedBy = 2,
  Any = 3
}

// Mirrors CharityCentral.Server.Models.ProbateListDateField
export enum ProbateListDateField {
  DateOfIssue = 0,
  Reported = 1,
  Verified = 2,
  Completed = 3
}

// Mirrors CharityCentral.Server.Models.ProbateListFilter
export interface ProbateListFilter {
  statuses: number[];
  userId: number | null;
  userRole: ProbateListUserRole;
  unassigned: boolean;
  dateField: ProbateListDateField;
  dateFrom: string | null;   // yyyy-MM-dd (UK calendar date)
  dateTo: string | null;
  deceasedName: string | null;
  probateId: string | null;  // string so large case numbers aren't rounded
  includeNonCharitable: boolean;
  pageIndex: number;
  pageSize: number;
  sortColumn: string | null;
  sortDirection: 'asc' | 'desc' | null;
}

export interface ProbateListPage {
  items: ProbateSummary[];
  totalCount: number;
  pageIndex: number;
}

export interface ProbateListIdsResult {
  probateIds: string[];  // strings - see utils/probate-id.ts
  truncated: boolean;
}
